import React from 'react';

import { HelpSidebarType } from '~/stores/HelpSidebar';

import { BottomLinks, HelpSidebarBase } from './Base';
import { HelpSidebarList, HelpSidebarListItem } from './Onboarding';

export const HelpSidebarRootEntity: React.FC = () => {
  const helpSidebar: HelpSidebarType[] = ['RootEntity'];

  return (
    <HelpSidebarBase helpSidebars={helpSidebar} headline="Root Entity">
      <HelpSidebarList>
        <HelpSidebarListItem>
          <h4>What is a Root Entity?</h4>
          <p>
            Root entities have special properties such as the ability to be parents of special account types. Accounts
            under a root entity have special use cases - they hold your company's money and are used for purposes like
            reserve accounts for fraud, holding accounts for overdrafts, and operating accounts for funding customer
            rewards.
          </p>
        </HelpSidebarListItem>
      </HelpSidebarList>
      <BottomLinks />
    </HelpSidebarBase>
  );
};
